export default "__VITE_PUBLIC_ASSET__90a31add__"